import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'PROCEDURES_FORM', {
  TITLE: 'Procedures',
  NAME: 'Name',
  STATE: 'State',
  URL: 'Link',
  FILES: 'Files',
  DELETE_DIALOG_TITLE: 'Delete procedure file',
  DELETE_DIALOG_MESSAGE: 'Are you sure you want to delete the file <strong>{{ name }}</strong>?',
  SUBMIT_BUTTON: 'Save',
  LOADING: 'Loading...',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'PROCEDURES_FORM', {
  TITLE: 'Trámites',
  NAME: 'Nombre',
  STATE: 'Estado',
  URL: 'Link',
  FILES: 'Archivos',
  DELETE_DIALOG_TITLE: 'Eliminar archivo del trámite',
  DELETE_DIALOG_MESSAGE: 'Estás seguro de querer eliminar el archivo <strong>{{ name }}</strong>?',
  SUBMIT_BUTTON: 'Guardar',
  LOADING: 'Cargando...',
});
